module.exports = __webpack_public_path__ + "vu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/vu.svg
// module id = 1140
// module chunks = 0